import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";

import { getUser } from "../../../../reducer";
import { reloadUser } from "../../../../data/user/actions";
import { saveUser } from "../../../Admin/reducer/actions";
import { getTranslate } from "react-localize-redux";
import { push } from "react-router-redux";


class Sites extends Component {


    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            password: '',
        }
    }

    componentDidMount() {
        this.setState({...this.props.user});
    }

    componentDidUpdate() {
        //this.prepareUser();
    }

    render() {
        return (

                    <Segment style={{padding: '8em 0em'}} vertical>
                        <Grid container stackable verticalAlign='middle' centered>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <Header as='h2' color='teal' textAlign='center'>
                                        {this.props.translate('admin.user.edit.header')}
                                    </Header>
                                    <Form size='large' onSubmit={() => {
                                        this.props.saveUser(this.state).then(()=>{
                                            this.props.success();
                                        })
                                    }}>
                                        <Segment stacked>
                                            <Form.Input
                                                label={this.props.translate('general.email')}
                                                fluid
                                                icon='mail outline'
                                                iconPosition='left'
                                                placeholder={this.props.translate('general.email')}
                                                type={'email'}
                                                value={this.state.email}
                                                onChange={(e) => {
                                                    this.setState({email: e.target.value})
                                                }}
                                            />
                                            <Form.Input
                                                label={this.props.translate('general.name')}
                                                fluid
                                                icon='user'
                                                iconPosition='left'
                                                placeholder={this.props.translate('general.name')}
                                                type={'text'}
                                                value={this.state.name}
                                                onChange={(e) => {
                                                    this.setState({name: e.target.value})
                                                }}
                                            />
                                            <Form.Input
                                                label={this.props.translate('general.password')}
                                                fluid
                                                icon='lock'
                                                iconPosition='left'
                                                placeholder={this.props.translate('general.password')}
                                                type={'password'}
                                                value={this.state.password}
                                                onChange={(e) => {
                                                    this.setState({password: e.target.value})
                                                }}
                                            />
                                            <Button type='submit'>{this.props.translate('general.save')}</Button>
                                        </Segment>
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
        );
    }

}


const mapStateToProps = state => {
    return {
        user: getUser(state),
        translate: getTranslate(state.localize),
    }
};

const mapDispatchToProps = (dispatch) => {
    return ({
        saveUser: (user) => {
            return dispatch(saveUser(user)).then(()=>{dispatch(reloadUser())})
        },
        success: ()=>{
            dispatch(push('/'));
        }
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Sites)



// WEBPACK FOOTER //
// ./src/scenes/Profile/scenes/Settings/index.js